<template>
      <BTabs pills>

        <BTab id="general" active>
          <template #title>
            <FeatherIcon icon="HomeIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">Datos generales</span>
          </template>
          <AccountsViewTabGeneral/>
        </BTab>
  
        <BTab id="lessons" @click="showTabBilling=true">
          <template #title>
            <FeatherIcon icon="BarChartIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">Datos facturación</span>
          </template>

          <AccountsViewTabBilling v-if="showTabBilling"/>
        </BTab>

        <BTab id="evaluations" @click="showTabIncomes=true">
          <template #title>
            <FeatherIcon icon="ArrowUpIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">Ingresos</span>
          </template>
          <AccountsViewTabIncomes v-if="showTabIncomes"/> 
        </BTab>

        <BTab id="grades" @click="showTabExpenses=true">
          <template #title>
            <FeatherIcon icon="ArrowDownIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">Gastos</span>
          </template>
          <AccountsViewTabExpenses v-if="showTabExpenses"/> 
        </BTab>
  
      </BTabs>
  </template>
  <script>
  import { BTab, BTabs, BCard, BAlert, BLink, } from 'bootstrap-vue'
  import { ref, onUnmounted, provide, watch} from '@vue/composition-api'
  import store from '@/store'
  import AccountsViewTabGeneral from './AccountsViewTabGeneral'
  import AccountsViewTabBilling from './AccountsViewTabBilling'
  import AccountsViewTabIncomes from './AccountsViewTabIncomes'
  import AccountsViewTabExpenses from './AccountsViewTabExpenses'

  import popups from '@/hooks/popups'
  import ability from '@/libs/acl/ability'
  import axios from '@axios'
  import router from '@/router'
  import { getAccount } from '@/composables/accountService'

  export default {
    components: { BTab, BTabs, BCard, BAlert, BLink, AccountsViewTabGeneral, AccountsViewTabBilling, AccountsViewTabIncomes, AccountsViewTabExpenses}, 
    setup() {

      const { deletePopupAxios } = popups()
        const account = ref(null)
        const showTabBilling = ref(false)
        const showTabIncomes = ref(false)
        const showTabExpenses = ref(false)

        provide('account', account)
        const fetchAccount = async function() {
          let response=await getAccount(router.currentRoute.params.id)
          account.value = response.data
          account.value.status == 1 ? account.value.status = true : account.value.status = false
          account.value.notif_email == 1 ? account.value.notif_email = true : account.value.notif_email = false
          account.value.emit_face == 1 ? account.value.emit_face = true : account.value.emit_face = false
          account.value.is_legal_entity == 1 ? account.value.is_legal_entity = true : account.value.is_legal_entity = false
        }
        fetchAccount()

        return {
            account,
            deletePopupAxios,
            showTabBilling,
            showTabIncomes,
            showTabExpenses
        }
    },
  }
  </script>
  
  <style>
  
  </style>
  